import { useState, useCallback, useEffect, useMemo } from 'react';
import { useIntl } from 'react-intl';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';

import { useStudentsSelector } from 'modules/students/components/StudentsSelector';

export default function useLessonForm({ lesson, students, loadingStudents, submitting, onSubmit }) {
  const intl = useIntl();

  const [name, setName] = useState(lesson?.name || moment().format('DD/MM/YYYY'));

  const lessonStudents = useMemo(() => {
    return lesson?.students.map((s) => s.student) || [];
  }, [lesson]);

  useEffect(() => {
    if (lesson?.name) {
      setName(lesson.name);
    }
  }, [lesson]);

  const handleConfirmStudentsSelection = useCallback(
    (selectedStudents) => {
      const formData = {
        name,
        students: selectedStudents?.map((s) => s._id) || [],
      };
      onSubmit(formData);
    },
    [name, onSubmit]
  );

  const studentsSelectorProps = useStudentsSelector({
    students,
    loading: loadingStudents,
    submitting,
    onConfirmSelection: handleConfirmStudentsSelection,
    submitButtonTitle: intl.formatMessage({ id: 'button.save.title' }),
    selectedStudents: lessonStudents,
    disabled: isEmpty(name),
    allowEmptySelection: true,
  });

  return {
    name,
    onChangeName: setName,

    studentsSelectorProps,
  };
}
